import * as Yup from "yup";

export const KeyImageSchema = Yup.object({
  imageTitle: Yup.string()
    .min(1, "Key image title cannot be blank")
    .max(25, "Key image title length exceeds maximum allowed length")
    .required("Key image title cannot be blank"),
});
